module.exports = __webpack_public_path__ + "static/img/arthroscopy-18.1269fb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-18.jpg
// module id = gVO/
// module chunks = 52